import { render } from "./ButtonSendCode.vue?vue&type=template&id=8d4a6f5c&ts=true"
import script from "./ButtonSendCode.vue?vue&type=script&lang=ts"
export * from "./ButtonSendCode.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__